<template>
  <div class="launch">
    <div class="launch-info">
      <p><i>Create your customized fan e-commerce experience...</i></p>
      <h1>Launch in 1 day for free!</h1>
    </div>
    <div class="cta-btn-launch">
      <a href="https://console.helixpay.ph/#/login" class="launch-signup">
        Sign-up for Free
      </a>
      <a
        href="https://dashboard.meetbit.io/meeting/HelixPay"
        class="launch-schedule"
      >
        Schedule Demo
      </a>
    </div>
  </div>
</template>

<style scoped>
.launch {
  width: 100%;
  margin: auto;
  height: inherit;
  align-items: center;
  justify-content: center;

  background-image: url('/img/cclaunch-bg-min.jpg');
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}

.launch-info {
  display: grid;
  width: 35rem;
  margin: auto;
  padding-top: 5rem;
  padding-top: 5rem;
  align-items: center;
  text-align: center;
  justify-content: center;
}

.launch-info p {
  color: white;
  opacity: 0.6;
  font-weight: 500;
  font-size: 1.3rem;
}

.launch h1 {
  width: 100%;
  color: white;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  padding-top: 1rem;
  text-align: center;
  line-height: 1.5;
}

.cta-btn-launch {
  display: flex;
  text-align: center;
  margin: auto;
  padding-top: 2rem;
  padding-bottom: 5rem;
  width: 30rem;
}

.launch-signup {
  width: 100%;
  background-color: white;
  color: black;
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;
  padding: 20px 30px;
  border-radius: 5px;
  margin-right: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  transition: 0.3s ease-in-out;
}

.launch-schedule {
  width: 100%;
  background-color: #9affe1;
  color: black;
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;
  padding: 20px 30px;
  border-radius: 5px;
  margin-right: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  transition: 0.3s ease-in-out;
}

.launch-signup:hover {
  background-color: rgb(228, 228, 228);
}

.launch-schedule:hover {
  background-color: #6fe2c0;
}

@media only screen and (max-width: 650px) {
  .launch {
    width: 100%;
  }

  .launch-info {
    width: 90%;
    margin: auto;
  }

  .launch h1 {
    font-size: 1.3rem;
  }

  .cta-btn-launch {
    display: grid;
    text-align: center;
    margin: auto;
    width: 60%;
  }

  .launch-signup {
    font-size: 1rem;
  }

  .launch-schedule {
    font-size: 1rem;
    margin-top: 0.5rem;
  }

  .launch-info p {
    font-size: 1rem;
  }
}
</style>
